"use strict";
(function() {
  "use strict";
  var root = document.querySelector("[data-lig-shop]");
  if (!root)
    return;
  var COLLECTION = root.getAttribute("data-collection") || "shop", PER_PAGE = 24, ROUTE_ROOT = (root.getAttribute("data-route-root") || "/").replace(/\/?$/, "/"), TEXT = JSON.parse(root.getAttribute("data-design-labels") || "{}"), contextParams = new URLSearchParams(location.search), familyMembers = /* @__PURE__ */ Object.create(null);
  var visitRanks = Object.create(null);
  var WINTER = COLLECTION === "winter-2026";
  // Winter garment test (deck "Winter Page Garment Test", Mike's go 2026-10-26, verdict Nov 10). The section's inline
  // script picks the arm before first paint: "a" = garment switch (boxes under the title below 1180 px, pills in the
  // bar from 1180 px), "b" = extra garment cards. data-lig-gt-count marks a visit that counts (50/50, not forced).
  var GT_ARM = WINTER ? (document.documentElement.getAttribute("data-lig-gt") === "b" ? "b" : "a") : "";
  var GT_COUNTED = WINTER && document.documentElement.getAttribute("data-lig-gt-count") === "1";
  function gtCount(step) {
    if (!GT_COUNTED) return;
    try { window.LIGSiteSignals && window.LIGSiteSignals.sendOnce && window.LIGSiteSignals.sendOnce("gt_" + step + "_" + GT_ARM); } catch (e) { /* never break the grid */ }
  }
  // One seed per visit (browser session): the tee pick and arm B's extra cards stay put while the shopper moves around.
  var visitSeed = (function() {
    var s = "";
    try { s = sessionStorage.getItem("lig-visit-seed-v1") || ""; } catch (e) { /* private mode */ }
    if (!s) {
      s = String(Math.floor(Math.random() * 4294967296));
      try { sessionStorage.setItem("lig-visit-seed-v1", s); } catch (e) { /* private mode */ }
    }
    return s;
  })();
  function visitHash(key) {
    for (var n = 2166136261, str = visitSeed + "|" + key, i = 0; i < str.length; i++) n = Math.imul(n ^ str.charCodeAt(i), 16777619);
    // FNV's low bits only track the characters' parity (every design flipped together); mix them before "% 2".
    n ^= n >>> 16, n = Math.imul(n, 0x85ebca6b), n ^= n >>> 13, n = Math.imul(n, 0xc2b2ae35), n ^= n >>> 16;
    return n >>> 0;
  }
  // How many sales-leading Winter designs keep the top spots before the per-visit shuffle (Oct 20 design: 4).
  // 0 = every design shuffled on every visit: Mike, 2026-10-23, for at least 7 days while Winter sales build up.
  var WINTER_LEADERS = 0;
  // "See every design as" (Winter, Mike 2026-10-23, option B): one tap shows every design as that garment.
  // [tile label, plural for the count line, icon]
  var SWITCH = { "Tees": ["Tee", "tees", "tee"], "Long Sleeves": ["Long sleeve", "long sleeves", "ls"], "Crewnecks": ["Crew", "crewnecks", "crew"], "Hoodies": ["Hoodie", "hoodies", "hoodie"], "Quarter Zips": ["Quarter zip", "quarter zips", "crew"], "Women's Tees": ["Tee", "tees", "tee"], "Youth Tees": ["Youth tee", "youth tees", "tee"], "Youth Crewnecks": ["Youth crew", "youth crewnecks", "crew"], "Toddler Tees": ["Toddler tee", "toddler tees", "tee"], "Toddler Crewnecks": ["Toddler crew", "toddler crewnecks", "crew"] };
  var GBODY = "M8.4 3.8 4.8 5.1 1.7 17.4l2.7.9 2.2-7.9v10.1h10.8V10.4l2.2 7.9 2.7-.9-3.1-12.3-3.6-1.3c-.6 1.4-1.9 2.2-3.6 2.2s-3-.8-3.6-2.2Z", GRIBS = "M6.6 18.4h10.8M2.2 15.6l2.6.9M21.8 15.6l-2.6.9";
  var GICON = { any: ["M5 6h14v12H5Z", "M5 12h14M12 6v12"], tee: ["M8.6 3.5 4.6 5.2 2.4 9.3l3 1.5 1.3-1.6V20.5h10.6V9.2l1.3 1.6 3-1.5-2.2-4.1-4-1.7c-.6 1.6-1.9 2.5-3.4 2.5s-2.8-.9-3.4-2.5Z"], ls: ["M8.6 3.5 5 4.8 1.8 17.6l2.5.9L7 10v10.5h10V10l2.7 8.5 2.5-.9L19 4.8l-3.6-1.3c-.6 1.6-1.9 2.5-3.4 2.5s-2.8-.9-3.4-2.5Z"], crew: [GBODY, GRIBS], hoodie: [GBODY, "M8.4 3.8C8.4 1.7 10 .9 12 .9s3.6.8 3.6 2.9", GRIBS + "M10.9 6.1v2.7M13.1 6.1v2.7M9.4 12.8h5.2l.7 2.4H8.7l.7-2.4Z"] };
  function garmentIcon(kind) {
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + GICON[kind].map(function(d) { return '<path d="' + d + '"/>'; }).join("") + "</svg>";
  }
  function pickedGarment() {
    return state.filters.garment.length === 1 && SWITCH[state.filters.garment[0]] ? state.filters.garment[0] : "";
  }
  // Arm A of the garment test draws this switch twice (under the title, and in the bar from 1180 px; CSS shows one).
  // Arm B never shows it, and it is a Unisex control: the Women's and Kids views have their own garments.
  function renderSwitch() {
    if (!els.gswitches.length) return;
    var g = groupByKey("garment"), picked = pickedGarment();
    var vals = valuesFor(g).filter(function(v) { return SWITCH[v] && countFor(g, v) > 0; }).slice(0, 4);
    var hide = GT_ARM === "b" || (WINTER && state.fit !== "Unisex") || (vals.length < 2 && !picked);
    [].forEach.call(els.gswitches, function(sw) { sw.hidden = hide; });
    if (hide) return;
    var tile = function(v, label, kind, on) {
      return '<button type="button" class="lig-gswitch__tile' + (v ? "" : " lig-gswitch__tile--any") + (on ? " is-on" : "") + '" data-gswitch="' + att(v) + '" aria-pressed="' + (on ? "true" : "false") + '">' + garmentIcon(kind) + "<span>" + esc(label) + "</span></button>";
    };
    var html = tile("", "Any", "any", !state.filters.garment.length) + vals.map(function(v) { return tile(v, SWITCH[v][0], SWITCH[v][2], picked === v); }).join("");
    [].forEach.call(els.gswitchTiles, function(box) { if (box.innerHTML !== html) box.innerHTML = html; });
    if (els.gswitchHint) {
      var n = picked ? filtered().length : 0;
      els.gswitchHint.textContent = picked ? n + (n === 1 ? " design comes as " : " designs come as ") + SWITCH[picked][1] + ". Tap it again to see every design." : els.gswitchHint.getAttribute("data-default") || "";
    }
  }
  // The same reviewed choices render in Liquid, before the feed replaces it.
  // Keep this independent of product gallery order and consent/experiments.
  var gridPhotos = Object.create(null), photoMap = root.querySelector('[data-lig-grid-photos]');
  if (COLLECTION === "winter-2026" && photoMap) {
    try {
      String(JSON.parse(photoMap.textContent)).split('|').forEach(function(row) {
        var fields = row.trim().split('~');
        if (/^\d+$/.test(fields[0]) && fields[1]) gridPhotos[fields[0]] = { img: fields[1], hover: fields[2] || "" };
      });
    } catch (err) { window.console && console.warn('[lig-shop] photo choices unavailable', err); }
  }
  function productPhotos(p) {
    var images = p.images || [];
    if (COLLECTION !== "winter-2026") return {
      img: images[0] && images[0].src || p.variants && p.variants[0] && p.variants[0].featured_image && p.variants[0].featured_image.src || "",
      hover: images[1] && images[1].src || ""
    };
    if (gridPhotos[String(p.id)]) return gridPhotos[String(p.id)];
    // New products without a reviewed choice may use a clearly labelled
    // photograph. Unknown images and mockups never become a cover or hover.
    var photos = images.filter(function(i) {
      var file = String(i.src || "").split('?')[0].split('/').pop();
      return !/ghost|editdesign|native-/i.test(file) && /lifestyle|macro|context|still-life|flat-?lay|hero/i.test(file);
    });
    return { img: photos[0] && photos[0].src || "", hover: photos[1] && photos[1].src || "" };
  }
  function loadFeaturedOrder() {
    var ids = [], seen = /* @__PURE__ */ Object.create(null);
    function page(n) {
      return fetch(ROUTE_ROOT + "collections/" + COLLECTION + "?view=lig-design-order" + (COLLECTION === "winter-2026" ? "&sort_by=best-selling" : "") + "&page=" + n).then(function(r) {
        if (!r.ok)
          throw new Error("Featured order HTTP " + r.status);
        return r.json();
      }).then(function(d) {
        if (!Array.isArray(d.ids))
          throw new Error("Invalid featured order feed");
        if (d.ids.forEach(function(id) {
          if (seen[String(id)])
            throw new Error("Featured order repeated a product");
          seen[String(id)] = true, ids.push(String(id));
        }), d.next_page) {
          if (d.next_page !== n + 1 || n >= 100)
            throw new Error("Invalid featured order pagination");
          return page(d.next_page);
        }
      });
    }
    return page(1).then(function() {
      return ids;
    }).catch(function(err) {
      return window.console && console.warn("[lig-shop] featured order unavailable", err), [];
    });
  }
  function applyFeaturedOrder(products, ids) {
    var rank = /* @__PURE__ */ Object.create(null);
    ids.forEach(function(id, i) {
      rank[String(id)] = i;
    }), products.sort(function(a, b) {
      var ar = rank[String(a.id)], br = rank[String(b.id)];
      return (ar === void 0 ? 1 / 0 : ar) - (br === void 0 ? 1 / 0 : br);
    });
  }
  var COLOR_FAMILIES = ["Navy", "Blue", "Green", "Red", "Pink", "Orange", "Yellow", "Purple", "Tan/Brown", "Grey", "Black", "White", "Natural/Cream", "Multi"], COLOR_HEX = { Navy: "#1f2a44", Blue: "#5b8fbf", Green: "#5b7b5e", Red: "#a23a36", Pink: "#e3a9bc", Orange: "#cc7a3f", Yellow: "#d8b34a", Purple: "#6f5b93", "Tan/Brown": "#b3895a", Grey: "#9b9b9b", Black: "#1a1a1a", White: "#ffffff", "Natural/Cream": "#ece2cd", Multi: "#c9bfa9" }, COLOR_RULES = [[/navy|midnight/, "Navy"], [/vintage white|solid white blend/, "White"], [/cream|natural|bone|oatmeal|ivory|sandshell|\bsand\b|chalk|eggshell/, "Natural/Cream"], [/tan|khaki|stone|pebble|camel|\bbrown\b|clay|\bdust\b|mushroom|sandstone|biscuit/, "Tan/Brown"], [/sage|forest|army|olive|moss|agave|\bgreen\b|hunter|pine|seafoam/, "Green"], [/teal|turquoise|aqua/, "Blue"], [/royal|sky|ocean|steel|prism|ice blue|light blue|baby blue|\bblue\b|marlin|denim|carolina|indigo/, "Blue"], [/maroon|burgundy|cardinal|brick|\brust\b|\bred\b|cranberry|wine/, "Red"], [/pink|rose|blush|mauve|coral|salmon/, "Pink"], [/orange|terracotta|rust orange|apricot/, "Orange"], [/gold|yellow|mustard|butter|honey|maize/, "Yellow"], [/purple|plum|lavender|violet|berry/, "Purple"], [/black|onyx|jet/, "Black"], [/charcoal|carbon|graphite|slate|\bgrey\b|\bgray\b|\bash\b|heather|silver|smoke|pewter|granite/, "Grey"], [/white/, "White"]];
  function colorFamily(raw) {
    var s = decodeEnt(String(raw || "")).toLowerCase().trim();
    if (!s)
      return null;
    for (var i = 0; i < COLOR_RULES.length; i++)
      if (COLOR_RULES[i][0].test(s))
        return COLOR_RULES[i][1];
    return "Multi";
  }
  var DISPLAY = { "Women's": "Women's Cut", Lake: "Lake Life", "Pickleball & Tennis": "Tennis & Pickleball", Heartland: "The Heartland", "West Of Everything": "West of Everything", "West of Everything": "West of Everything" }, GROUPS = [{ key: "garment", label: TEXT.garment || "Garment", source: "garment", order: ["Tees", "Long Sleeves", "Crewnecks", "Hoodies", "Quarter Zips", "Hooded Long Sleeves", "Youth Tees", "Youth Crewnecks", "Toddler Tees", "Toddler Crewnecks", "Baby One-Pieces", "Women's Tees"] }, { key: "category", label: "Category", source: "tag", order: ["Tees", "Long Sleeves", "Tank Tops", "Sweatshirts & Hoodies", "Pajamas", "Swimwear", "Hats", "Bags & Totes", "Drinkware", "Blankets", "Pillows", "Wall Art", "Phone & Laptop Cases", "Decals & Stickers", "Dog Gear", "Home & Kitchen", "Stationery & Paper", "Bandanas", "Accessories"] }, { key: "interest", label: "Interests", source: "tag", group: "collections", order: ["Beach", "Lake", "Boating", "Surfing", "Fishing", "Golf", "Pickleball & Tennis", "Hunting", "Camping", "Hiking", "Skiing", "Baseball", "Soccer", "Classic Rides", "Farm Life"] }, { key: "occasion", label: "Occasions", source: "tag", group: "collections", order: ["Summer", "4th of July", "Father's Day", "Mother's Day", "Holiday", "Winter", "Valentine's Day"] }, { key: "region", label: "Regions", source: "tag", group: "collections", order: ["Heartland", "East Coast", "High Country", "West Of Everything"] }, { key: "color", label: "Color", source: "color" }], TAG2GROUP = {};
  GROUPS.forEach(function(g) {
    g.source === "tag" && g.order.forEach(function(v) {
      TAG2GROUP[v.toLowerCase()] = g.key;
    });
  });
  var FIT_TAGS = { "women's": "Women's", womens: "Women's", kids: "Kids" }, state = { all: [], fit: "Unisex", filters: {}, sort: "manual", shown: PER_PAGE, ready: false, q: "", qTerms: [] };
  GROUPS.forEach(function(g) {
    state.filters[g.key] = [];
  });
  var ED_TILES = [];
  function loadTiles() {
    var el = document.querySelector("[data-lig-ed-tiles]");
    if (el)
      try {
        (JSON.parse(el.textContent) || []).forEach(function(t) {
          if (!(!t || !t.img)) {
            var cats = String(t.cats || "all").split(",").map(function(s) {
              return handleize(s);
            }).filter(Boolean);
            ED_TILES.push({ cats, img: t.img, title: t.title || "", sub: t.sub || "", url: t.url || "" });
          }
        });
      } catch (e) {
      }
  }
  var els = {};
  // Keep the sorted view between batches; only a filter/sort change replaces it.
  var viewList = [], pagingObserver = null, observedTail = null;
  var pagingFrame = null, tailCheckFrame = null, pagingRevision = 0, pagingBusy = false, autoPaused = false;
  function cancelPaging() {
    pagingRevision++;
    if (pagingFrame !== null) window.cancelAnimationFrame(pagingFrame);
    if (tailCheckFrame !== null) window.cancelAnimationFrame(tailCheckFrame);
    pagingFrame = null;
    tailCheckFrame = null;
    pagingBusy = false;
    els.grid.setAttribute("aria-busy", "false");
  }
  function canAutoLoad() {
    return state.ready && !pagingBusy && !autoPaused && !document.hidden && root.isConnected &&
      !els.overlay.classList.contains("is-open") &&
      !els.more.parentElement.contains(document.activeElement) && state.shown < viewList.length;
  }
  function observeTail() {
    if (!pagingObserver) return;
    pagingObserver.disconnect();
    observedTail = null;
    if (!state.ready || autoPaused || state.shown >= viewList.length) return;
    var cards = els.grid.querySelectorAll(".lig-card");
    observedTail = cards[cards.length - 1];
    if (observedTail) {
      pagingObserver.observe(observedTail);
      checkTailPosition();
    }
  }
  function checkTailPosition() {
    if (tailCheckFrame !== null || !canAutoLoad()) return;
    // Fast swipes can jump completely over the observer's intersection window.
    // At most one lightweight position check per animation frame catches them.
    tailCheckFrame = window.requestAnimationFrame(function() {
      tailCheckFrame = null;
      if (canAutoLoad() && observedTail && observedTail.getBoundingClientRect().top <= window.innerHeight + 600)
        appendNext(false);
    });
  }
  function updatePaging() {
    if (COLLECTION === "winter-2026" && window.LIGMerchandising) window.LIGMerchandising.observe();
    var shown = Math.min(state.shown, viewList.length), more = shown < viewList.length;
    els.more.style.display = more && (COLLECTION !== "winter-2026" || !pagingObserver || autoPaused) ? "" : "none";
    els.more.disabled = pagingBusy;
    els.more.textContent = pagingBusy ? "Loading…" : "Load more";
    els.progress.textContent = pagingBusy ? "Loading more items…" :
      (viewList.length ? "Showing " + shown + " of " + viewList.length + " items" : "No items");
    if (els.pause) {
      els.pause.hidden = !more;
      els.pause.textContent = autoPaused ? "Resume loading" : "Pause loading";
      els.pause.setAttribute("aria-label", autoPaused ? "Resume automatic product loading" : "Pause automatic product loading");
      els.pause.setAttribute("aria-pressed", autoPaused ? "true" : "false");
    }
    observeTail();
  }
  function appendNext(manual) {
    if (!state.ready || pagingBusy || state.shown >= viewList.length || (!manual && !canAutoLoad())) return;
    var revision = pagingRevision, start = state.shown;
    pagingBusy = true;
    els.grid.setAttribute("aria-busy", "true");
    updatePaging();
    pagingFrame = window.requestAnimationFrame(function() {
      pagingFrame = null;
      if (revision !== pagingRevision || !root.isConnected) return;
      // A dialog or keyboard control may have gained focus since the observer ran.
      if (!manual && (autoPaused || document.hidden || els.overlay.classList.contains("is-open") ||
          els.more.parentElement.contains(document.activeElement))) {
        pagingBusy = false;
        els.grid.setAttribute("aria-busy", "false");
        updatePaging();
        return;
      }
      try {
        var end = Math.min(start + PER_PAGE, viewList.length), html = "";
        for (var i = start; i < end; i++) html += card(viewList[i], i);
        // Retain image elements, keyboard focus and scroll anchors already on screen.
        els.grid.insertAdjacentHTML("beforeend", html);
        state.shown = end;
        if (manual) {
          var cards = els.grid.querySelectorAll(".lig-card");
          if (cards[start]) cards[start].focus({ preventScroll: true });
        }
      } catch (err) {
        autoPaused = true;
        if (window.console) console.error("[lig-shop] append failed; manual retry available", err);
      } finally {
        pagingBusy = false;
        els.grid.setAttribute("aria-busy", "false");
        updatePaging();
      }
    });
  }
  function setupPaging() {
    var wrap = els.more.parentElement;
    els.progress = document.createElement("p");
    els.progress.setAttribute("role", "status");
    els.progress.setAttribute("aria-live", "polite");
    els.progress.setAttribute("aria-atomic", "true");
    els.progress.setAttribute("data-scroll-progress", "");
    els.progress.style.cssText = "font-size:.82rem;margin:.75rem 0;color:var(--s-muted);";
    wrap.appendChild(els.progress);
    if ("IntersectionObserver" in window) {
      pagingObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.target === observedTail && entry.isIntersecting && canAutoLoad()) appendNext(false);
        });
      }, { rootMargin: "0px 0px 600px 0px", threshold: 0 });
      // Loading is automatic everywhere; no Pause control in the toolbar (Mike, 2026-10-23).
      // Re-observe after closing a filter dialog, changing tabs or using the fallback.
      wrap.addEventListener("focusout", function() { observeTail(); });
      document.addEventListener("visibilitychange", observeTail);
      window.addEventListener("pageshow", observeTail);
      window.addEventListener("scroll", checkTailPosition, { passive: true });
    }
  }
  function load() {
    var products = [], seenPages = /* @__PURE__ */ Object.create(null);
    function page(n) {
      return fetch(ROUTE_ROOT + "collections/" + COLLECTION + "/products.json?limit=250&page=" + n, { headers: { Accept: "application/json" } }).then(function(r) {
        if (!r.ok)
          throw new Error("Collection HTTP " + r.status);
        return r.json();
      }).then(function(d) {
        var arr = d && d.products || [];
        if (arr.length) {
          var pageKey = String(arr[0].id);
          if (seenPages[pageKey])
            throw new Error("Collection feed repeated a page");
          seenPages[pageKey] = true;
        }
        if (arr.forEach(function(p) {
          isHidden(p) || products.push(index(p));
        }), arr.length === 250) {
          if (n >= 100)
            throw new Error("Collection feed exceeded page budget");
          return page(n + 1);
        }
      });
    }
    return Promise.all([page(1), loadFeaturedOrder(), window.LIGMerchandising ? window.LIGMerchandising.ready : Promise.resolve()]).then(function(loaded) {
      applyFeaturedOrder(products, loaded[1]), products.forEach(function(p) {
        var key = familyKey(p);
        (familyMembers[key] || (familyMembers[key] = [])).push(p);
      });
      state.all = WINTER ? oneTeePerDesign(products) : products;
      if (COLLECTION === "winter-2026") {
        var keys = Object.keys(familyMembers);
        for (var i = keys.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1)), key = keys[i];
          keys[i] = keys[j]; keys[j] = key;
        }
        keys.forEach(function(key, i) { visitRanks[key] = i; });
      }
    });
  }
  // Mike's one-tee rule (2026-10-24): a design with both a Heavyweight Tee and a Lightweight Tee shows ONE of them per
  // visit, picked 50/50 and sticky for the visit, in every view and both test arms; the other is never a card.
  // familyMembers keeps both, so "Choose your garment · N options" still counts every garment the product page offers.
  function oneTeePerDesign(products) {
    var drop = Object.create(null);
    Object.keys(familyMembers).forEach(function(key) {
      var heavy = familyMembers[key].filter(function(p) { return p.garment === "Heavyweight Tee"; });
      var light = familyMembers[key].filter(function(p) { return p.garment === "Lightweight Tee"; });
      if (!heavy.length || !light.length) return;
      // A lightweight has no photos of its own on the grid (Mike, 10/26: "no need to remake 52 images"): its
      // heavyweight's reviewed cover and hover stand in when the manifest has no row for it.
      light.forEach(function(p) {
        if (!gridPhotos[String(p.id)] && heavy[0].img) { p.img = heavy[0].img; p.hover = heavy[0].hover; }
      });
      var keep = visitHash(key + "|tee") % 2 ? light : heavy, other = keep === light ? heavy : light;
      var open = function(list) { return list.some(function(p) { return p.available; }); };
      if (!open(keep) && open(other)) { var t = keep; keep = other; other = t; }
      other.forEach(function(p) { drop[String(p.id)] = true; });
    });
    return products.filter(function(p) { return !drop[String(p.id)]; });
  }
  function isHidden(p) {
    var tags = p && p.tags;
    if (typeof tags == "string" && (tags = tags.split(",")), !tags || !tags.length)
      return false;
    for (var i = 0; i < tags.length; i++)
      if (String(tags[i]).trim().toLowerCase() === "hidden")
        return true;
    return false;
  }
  function index(p) {
    var prices = [], avail = false, colorRaw = [], printChoices = [], optIdx = {};
    (p.options || []).forEach(function(o) {
      optIdx[(o.name || "").toLowerCase()] = o.position;
    }), (p.variants || []).forEach(function(v) {
      var pr = parseFloat(v.price);
      isNaN(pr) || prices.push(pr), v.available && (avail = true);
      var pos = optIdx.color, c = pos ? v["option" + pos] : null;
      c && colorRaw.push(c);
      var printPos = optIdx.print, print = printPos ? v["option" + printPos] : null;
      print && printChoices.push(print);
    });
    var photos = productPhotos(p), img = photos.img, facets = { category: [], interest: [], occasion: [], region: [], color: [], garment: [] }, design = "", designTitle = "", garment = "", featured = false, fit = "Unisex", tagBlob = [], tags = typeof p.tags == "string" ? p.tags.split(",") : p.tags || [];
    tags.forEach(function(t) {
      var key = decodeEnt(String(t)), lk = key.toLowerCase().trim();
      lk.indexOf("lig-design:") === 0 && (design = key.slice(11).trim()), lk.indexOf("lig-design-title:") === 0 && (designTitle = key.slice(17).trim()), lk.indexOf("lig-garment:") === 0 && (garment = key.slice(12).trim()), lk === "lig-design-featured" && (featured = true);
      var g = TAG2GROUP[lk];
      g && pushUniq(facets[g], canonicalTagValue(g, key)), FIT_TAGS[lk] && (fit = FIT_TAGS[lk]), (g || FIT_TAGS[lk]) && tagBlob.push(lk);
    }), facets.color = uniq(colorRaw.map(colorFamily).filter(Boolean));
    var garmentFacet = { "T-Shirts": "Tees", Tee: "Tees", "Long-Sleeve Tees": "Long Sleeves", "Long Sleeves": "Long Sleeves", "Crewneck Sweatshirts": "Crewnecks", Sweatshirts: "Crewnecks", "Quarter Zip": "Quarter Zips", Hoodies: "Hoodies", "Hooded Long-Sleeve Tees": "Hooded Long Sleeves", "Youth T-Shirts": "Youth Tees", "Youth Sweatshirts": "Youth Crewnecks", "Toddler T-Shirts": "Toddler Tees", "Kids Sweatshirts": "Toddler Crewnecks", "Baby One-Pieces": "Baby One-Pieces", "Women's Relaxed Tees": "Women's Tees", "Women's V-Neck Tees": "Women's Tees" }[p.product_type];
    return garmentFacet && (facets.garment = [garmentFacet]), { id: p.id, printCount: uniq(printChoices).length, design, designTitle, garment, featured, title: p.title, handle: p.handle, url: ROUTE_ROOT + "products/" + p.handle, img: img ? sized(img) : "", hover: photos.hover ? sized(photos.hover) : "", price: prices.length ? Math.min.apply(null, prices) : 0, available: avail, created: p.created_at || "", fit, facets, search: (String(p.title || "") + " " + tagBlob.join(" ")).toLowerCase() };
  }
  function canonicalTagValue(gkey, raw) {
    var g = groupByKey(gkey);
    if (!g || !g.order)
      return raw;
    for (var lr = raw.toLowerCase(), i = 0; i < g.order.length; i++)
      if (g.order[i].toLowerCase() === lr)
        return g.order[i];
    return raw;
  }
  function sized(u) {
    if (COLLECTION === "winter-2026") return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=720';
    return u.replace(/(\.[a-z]+)(\?|$)/i, "_720x$1$2");
  }
  function fitMatch(p) {
    return state.fit === "Unisex" ? p.fit === "Unisex" : p.fit === state.fit;
  }
  function matches(p, exceptKey) {
    if (exceptKey !== "__fit__" && !fitMatch(p))
      return false;
    for (var t = 0; t < state.qTerms.length; t++)
      if (p.search.indexOf(state.qTerms[t]) < 0)
        return false;
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i], sel = state.filters[g.key];
      if (!(!sel.length || g.key === exceptKey)) {
        var vals = p.facets[g.key] || [];
        if (!sel.some(function(v) {
          return vals.indexOf(v) > -1;
        }))
          return false;
      }
    }
    return true;
  }
  function familyKey(p) {
    return p.design ? p.design + "|" + p.fit : "product:" + p.id;
  }
  function groupDesigns(products) {
    var groups = /* @__PURE__ */ Object.create(null), keys = [];
    return products.forEach(function(p) {
      var key = familyKey(p);
      groups[key] || (groups[key] = [], keys.push(key)), groups[key].push(p);
    }), keys.map(function(key) {
      var members = groups[key], available = members.filter(function(p) {
        return p.available;
      }), choices = available.length ? available : members;
      return choices.find(function(p) {
        return p.featured;
      }) || choices[0];
    });
  }
  function filtered() {
    return groupDesigns(state.all.filter(function(p) {
      return matches(p, null);
    }));
  }
  function countFor(g, value) {
    var base = state.all.filter(function(p) {
      return matches(p, g.key);
    });
    return groupDesigns(base.filter(function(p) {
      return (p.facets[g.key] || []).indexOf(value) > -1;
    })).length;
  }
  function fitCount(val) {
    return groupDesigns(state.all.filter(function(p) {
      return matches(p, "__fit__");
    }).filter(function(p) {
      return val === "Unisex" ? p.fit === "Unisex" : p.fit === val;
    })).length;
  }
  function valuesFor(g) {
    var present = {};
    state.all.forEach(function(p) {
      (p.facets[g.key] || []).forEach(function(v) {
        present[v] = 1;
      });
    });
    var keys = Object.keys(present);
    return g.order ? keys.sort(function(a, b) {
      var ia = g.order.indexOf(a), ib = g.order.indexOf(b);
      return ia < 0 && (ia = 999), ib < 0 && (ib = 999), ia - ib || a.localeCompare(b);
    }) : g.source === "color" ? keys.sort(function(a, b) {
      return COLOR_FAMILIES.indexOf(a) - COLOR_FAMILIES.indexOf(b);
    }) : keys.sort(), keys;
  }
  function lbl(v) {
    return DISPLAY[v] || v;
  }
  function renderFacets() {
    var html = "";
    // Winter (deck, 10/24): no Garment pills in Filters (Category covers it, the switch picks crew vs hoodie), and
    // Kids is a Category tile because the phone bar keeps only Unisex · Women's.
    WINTER || (html += facetBlock(groupByKey("garment"), "chips")), html += facetBlock(groupByKey("category"), "tiles", WINTER ? kidsTile() : "");
    var subs = GROUPS.filter(function(g) {
      return g.group === "collections";
    }), subHtml = "";
    subs.forEach(function(g) {
      var vals = valuesFor(g).map(function(v) {
        return { v, c: countFor(g, v) };
      }).filter(function(x) {
        return x.c > 0;
      });
      vals.length && (subHtml += '<div class="ligf-sub"><h4 class="ligf-sub__t">' + g.label + '</h4><div class="ligf-chips">' + vals.map(function(x) {
        return chip(g.key, x.v, x.c);
      }).join("") + "</div></div>");
    }), subHtml && (html += '<section class="ligf-block"><h3 class="ligf-block__t">Collections</h3>' + subHtml + "</section>"), html += facetBlock(groupByKey("color"), "swatches"), els.facets.innerHTML = html;
  }
  function kidsTile() {
    var c = fitCount("Kids"), on = state.fit === "Kids";
    return c ? '<button type="button" class="ligf-tile ligf-tile--fit' + (on ? " is-on" : "") + '" aria-pressed="' + (on ? "true" : "false") + '" data-fit-tile="Kids"><span>Kids</span><em>' + c + "</em></button>" : "";
  }
  function facetBlock(g, kind, extra) {
    var vals = valuesFor(g).map(function(v) {
      return { v, c: countFor(g, v) };
    }).filter(function(x) {
      return x.c > 0;
    });
    if (!vals.length && !extra)
      return "";
    var inner;
    return kind === "tiles" ? inner = '<div class="ligf-tiles">' + vals.map(function(x) {
      return tile(g.key, x.v, x.c);
    }).join("") + (extra || "") + "</div>" : kind === "swatches" ? inner = '<div class="ligf-swatches">' + vals.map(function(x) {
      return swatchOpt(g.key, x.v, x.c);
    }).join("") + "</div>" : inner = '<div class="ligf-chips">' + vals.map(function(x) {
      return chip(g.key, x.v, x.c);
    }).join("") + "</div>", '<section class="ligf-block"><h3 class="ligf-block__t">' + g.label + "</h3>" + inner + "</section>";
  }
  function isOn(key, v) {
    return state.filters[key].indexOf(v) > -1;
  }
  function tile(key, v, c) {
    return '<button type="button" class="ligf-tile' + (isOn(key, v) ? " is-on" : "") + '" aria-pressed="' + (isOn(key, v) ? "true" : "false") + '" data-g="' + key + '" data-v="' + att(v) + '"><span>' + esc(lbl(v)) + "</span><em>" + c + "</em></button>";
  }
  function chip(key, v, c) {
    return '<button type="button" class="ligf-chipopt' + (isOn(key, v) ? " is-on" : "") + '" aria-pressed="' + (isOn(key, v) ? "true" : "false") + '" data-g="' + key + '" data-v="' + att(v) + '">' + esc(lbl(v)) + " <em>" + c + "</em></button>";
  }
  function swatchOpt(key, v, c) {
    var hex = COLOR_HEX[v] || "#ccc", ring = /(white|natural|cream)/i.test(v) ? " ligf-sw--light" : "";
    return '<button type="button" class="ligf-sw' + ring + (isOn(key, v) ? " is-on" : "") + '" aria-pressed="' + (isOn(key, v) ? "true" : "false") + '" data-g="' + key + '" data-v="' + att(v) + '" title="' + esc(lbl(v)) + " (" + c + ')"><span class="ligf-sw__dot" style="background:' + hex + '"></span><span class="ligf-sw__lbl">' + esc(lbl(v)) + "</span></button>";
  }
  function renderApplied() {
    var chips = [];
    GROUPS.forEach(function(g) {
      state.filters[g.key].forEach(function(v) {
        chips.push('<button class="ligf-pill" data-g="' + g.key + '" data-v="' + att(v) + '">' + esc(lbl(v)) + ' <span aria-hidden="true">&times;</span></button>');
      });
    }), els.applied.innerHTML = chips.length ? '<span class="ligf-applied__lbl">Filtering by</span>' + chips.join("") + '<button class="ligf-applied__clear" data-clear>Clear all</button>' : "", els.applied.style.display = chips.length ? "" : "none";
  }
  function sortList(list) {
    var a = list.slice(), s = state.sort;
    s === "price-asc" ? a.sort(function(x, y) {
      return x.price - y.price;
    }) : s === "price-desc" ? a.sort(function(x, y) {
      return y.price - x.price;
    }) : s === "title-asc" ? a.sort(function(x, y) {
      return x.title.localeCompare(y.title);
    }) : s === "newest" && a.sort(function(x, y) {
      return (y.created || "").localeCompare(x.created || "");
    });
    if (COLLECTION === "winter-2026" && s === "manual") {
      var available = a.filter(function(p) { return p.available; });
      var unavailable = a.filter(function(p) { return !p.available; });
      var leaders = available.slice(0, WINTER_LEADERS), discovery = available.slice(WINTER_LEADERS);
      discovery.sort(function(x, y) { return visitRanks[familyKey(x)] - visitRanks[familyKey(y)]; });
      return leaders.concat(discovery, unavailable);
    }
    return a;
  }
  function renderCounts(list) {
    updatePaging();
    var n = list.length, label = n + (COLLECTION === "winter-2026" ? (n === 1 ? " design" : " designs") : (n === 1 ? " item" : " items")), picked = pickedGarment();
    els.count && (els.count.textContent = picked && n ? n + (n === 1 ? " design comes as " : " designs come as ") + SWITCH[picked][1] : label), els.view && (els.view.textContent = n ? "View " + label : "No items");
    renderSwitch();
    if (els.allBtn) {
      var shows = pickedLabel();
      els.allLabel.textContent = shows, els.allBtn.classList.toggle("is-on", shows !== "All products");
      els.allBtn.setAttribute("aria-label", shows === "All products" ? "Showing all products. Open filters" : "Showing " + shows + ". Open filters");
    }
    if (els.searchBtn) {
      els.searchLabel.textContent = state.q ? state.q : "", els.searchWrap.classList.toggle("has-q", !!state.q);
    }
    var nf = activeCount();
    els.fcount && (els.fcount.textContent = nf ? String(nf) : "", els.fcount.style.display = nf ? "" : "none"), announce(n);
  }
  function announce(count) {
    var act = null, cats = state.filters.category;
    cats.length === 1 ? act = { key: handleize(cats[0]), label: lbl(cats[0]) } : !cats.length && state.fit !== "Unisex" && (act = { key: handleize(state.fit), label: lbl(state.fit) });
    try {
      document.dispatchEvent(new CustomEvent("lig:shopstate", { detail: { state: { fit: state.fit, filters: state.filters, sort: state.sort, q: state.q }, count, activeKey: act ? act.key : "", activeLabel: act ? act.label : "" } }));
    } catch (e) {
    }
  }
  // What the phone bar's "All products" button says: what is picked, so the shopper sees the grid is narrowed.
  function pickedLabel() {
    var picks = state.fit === "Kids" ? ["Kids"] : [];
    GROUPS.forEach(function(g) {
      state.filters[g.key].forEach(function(v) { picks.push(lbl(v)); });
    });
    state.q && picks.push("“" + state.q + "”");
    return !picks.length ? "All products" : picks.length === 1 ? picks[0] : picks.length + " filters";
  }
  function renderGrid() {
    cancelPaging();
    var designs = sortList(filtered()), list = withExtras(designs), slice = list.slice(0, state.shown);
    viewList = list;
    slice.length ? els.grid.innerHTML = gridHTML(slice) : els.grid.innerHTML = state.q ? searchEmpty() : '<p class="ligf-empty">No pieces match those filters yet. Try removing one.</p>', renderCounts(designs);
  }
  // Arm B of the garment test: each design that comes in several garments shows up once more, 6–9 cards after its
  // first card, as another garment with its own photo (never the same picture twice, never next to itself; the two
  // tees are one slot, already settled by oneTeePerDesign). Featured order only: a sort the shopper picks, or a filter
  // that leaves one garment, keeps one card per design. The design count ("View N designs") never includes these.
  function withExtras(designs) {
    if (GT_ARM !== "b" || state.sort !== "manual") return designs;
    var members = Object.create(null), photo = function(u) { return String(u || "").split("?")[0]; };
    state.all.forEach(function(p) {
      if (p.available && matches(p, null)) (members[familyKey(p)] || (members[familyKey(p)] = [])).push(p);
    });
    var out = [], pending = [];
    function place(atEnd) {
      pending.sort(function(x, y) { return x.at - y.at; });
      while (pending.length && (pending[0].at <= out.length || atEnd)) {
        var next = pending.shift();
        if (out.length - next.from >= 6) out.push(next.p);
      }
    }
    designs.forEach(function(p) {
      place(false);
      out.push(p);
      if (!p.available) return;
      // Only a garment with a reviewed photo (a winter-grid-photos.json row; lightweights use their heavyweight's).
      var key = familyKey(p), others = (members[key] || []).filter(function(m) {
        return m !== p && m.garment && m.garment !== p.garment && m.img && photo(m.img) !== photo(p.img) && (gridPhotos[String(m.id)] || m.garment === "Lightweight Tee");
      });
      if (!others.length) return;
      var extra = Object.create(others[visitHash(key + "|extra") % others.length]);
      extra.gtExtra = true;
      pending.push({ p: extra, from: out.length - 1, at: out.length - 1 + 6 + visitHash(key + "|gap") % 4 });
    });
    place(true);
    return out;
  }
  function gridHTML(slice) {
    var tiles = eligibleTiles(), html = "";
    tiles.length && slice.length && (html += edTile(tiles[0]));
    for (var i = 0; i < slice.length; i++)
      html += card(slice[i], i);
    return html;
  }
  function searchEmpty() {
    return '<div class="ligf-empty ligf-empty--search"><p>Nothing here matches \u201C' + esc(state.q) + '\u201D.</p><a class="ligf-empty__cta" href="/search?q=' + encodeURIComponent(state.q) + '">Search the whole store &rarr;</a></div>';
  }
  function weaveServerTiles() {
    var tiles = eligibleTiles();
    !tiles.length || !els.grid || els.grid.querySelector(".lig-card") && els.grid.insertAdjacentHTML("afterbegin", edTile(tiles[0]));
  }
  function eligibleTiles() {
    if (!ED_TILES.length)
      return [];
    var active = state.filters.category.map(handleize);
    return ED_TILES.filter(function(t) {
      if (t.cats.indexOf("all") > -1)
        return true;
      for (var i = 0; i < active.length; i++)
        if (t.cats.indexOf(active[i]) > -1)
          return true;
      return false;
    });
  }
  function edTile(t) {
    var inner = '<div class="lig-edtile__media"><img class="lig-edtile__img" loading="lazy" src="' + att(t.img) + '" alt=""></div><div class="lig-edtile__panel">' + (t.title ? '<div class="lig-edtile__t">' + esc(t.title) + "</div>" : "") + (t.sub ? '<div class="lig-edtile__s">' + esc(t.sub) + "</div>" : "") + (t.url ? '<span class="lig-edtile__cta">Shop</span>' : "") + "</div>";
    return t.url ? '<a class="lig-edtile" href="' + att(t.url) + '">' + inner + "</a>" : '<div class="lig-edtile">' + inner + "</div>";
  }
  function activeCount() {
    var n = 0;
    return GROUPS.forEach(function(g) {
      n += state.filters[g.key].length;
    }), state.fit !== "Unisex" && (n += 1), n;
  }
  function card(p, i) {
    var eager = i < 8, options = uniq((familyMembers[familyKey(p)] || []).map(function(m) {
      return m.garment;
    })), title = p.designTitle || p.title, note = p.printCount > 1 ? "Choose your print · " + p.printCount + " prints" : options.length > 1 ? "Choose your garment · " + options.length + " options" : "";
    return '<a class="lig-card" data-merch-product="' + att(String(p.id)) + '" data-design="' + att(familyKey(p)) + '"' + (p.gtExtra ? ' data-gt-extra="1"' : "") + ' href="' + att(p.url) + '"><div class="lig-card__img">' + (p.img ? '<img class="lig-card__primary" decoding="async" ' + (eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + ' src="' + att(p.img) + '" alt="' + att(p.title) + '">' : "") + (p.hover && p.hover !== p.img ? '<img class="lig-card__alternate" decoding="async" loading="lazy" src="' + att(p.hover) + '" alt="" aria-hidden="true">' : "") + (p.available ? "" : '<span class="lig-card__so">Sold out</span>') + '</div><div class="lig-card__t">' + esc(title) + '</div><div class="lig-card__p">' + (p.garment ? esc(p.garment) + " \xB7 " : "") + "$" + p.price.toFixed(2).replace(/\.00$/, "") + "</div>" + (note ? '<div class="lig-card__options">' + esc(note) + "</div>" : "") + "</a>";
  }
  function renderFit() {
    [].forEach.call(els.fitBtns, function(b) {
      var v = b.getAttribute("data-fit-val"), on = v === state.fit;
      b.classList.toggle("is-on", on), b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function renderAll() {
    renderFit(), renderGrid();
  }
  function renderOverlay() {
    renderApplied(), renderFacets(), renderGrid();
  }
  function readURL() {
    var m = location.pathname.match(/\/collections\/[^\/]+\/(.+)$/);
    m && decodeURIComponent(m[1]).split("+").forEach(applyHandle);
    var q = new URLSearchParams(location.search), f = q.get("fit");
    f && (f.toLowerCase() === "womens" || f.toLowerCase() === "women's" ? state.fit = "Women's" : f.toLowerCase() === "kids" ? state.fit = "Kids" : f.toLowerCase() === "unisex" && (state.fit = "Unisex")), GROUPS.forEach(function(g) {
      var raw = q.get(g.key);
      raw && raw.split(",").forEach(function(val) {
        addSel(g.key, canonByHandleOrName(g, val));
      });
    }), applyQ(q.get("q") || "");
    var s = q.get("sort");
    s && (state.sort = s);
  }
  function applyHandle(h) {
    if (h = h.trim(), !!h) {
      if (h === "womens") {
        state.fit = "Women's";
        return;
      }
      if (h === "kids") {
        state.fit = "Kids";
        return;
      }
      if (h === "unisex") {
        state.fit = "Unisex";
        return;
      }
      GROUPS.forEach(function(g) {
        g.source === "tag" && g.order.forEach(function(v) {
          handleize(v) === h && addSel(g.key, v);
        });
      }), groupByKey("color") && COLOR_FAMILIES.forEach(function(v) {
        handleize(v) === h && addSel("color", v);
      });
    }
  }
  function canonByHandleOrName(g, val) {
    for (var vals = g.source === "color" ? COLOR_FAMILIES : g.order || [], i = 0; i < vals.length; i++)
      if (vals[i] === val || handleize(vals[i]) === handleize(val))
        return vals[i];
    return val;
  }
  function writeURL() {
    var path = ROUTE_ROOT + "collections/" + COLLECTION, q = new URLSearchParams();
    ["view", "preview_theme_id", "pb", "_ab", "_fd", "_sc"].forEach(function(key) {
      contextParams.has(key) && q.set(key, contextParams.get(key));
    });
    var tagHandles = [];
    state.fit !== "Unisex" && tagHandles.push(handleize(state.fit)), GROUPS.forEach(function(g) {
      g.source === "tag" && state.filters[g.key].forEach(function(v) {
        tagHandles.push(handleize(v));
      });
    }), tagHandles.length === 1 ? path += "/" + tagHandles[0] : tagHandles.length > 1 && (state.fit !== "Unisex" && q.set("fit", handleize(state.fit)), GROUPS.forEach(function(g) {
      g.source === "tag" && state.filters[g.key].length && q.set(g.key, state.filters[g.key].map(handleize).join(","));
    })), GROUPS.forEach(function(g) {
      g.source !== "tag" && state.filters[g.key].length && q.set(g.key, state.filters[g.key].map(handleize).join(","));
    }), state.q && q.set("q", state.q), state.sort && state.sort !== "manual" && q.set("sort", state.sort);
    var qs = q.toString();
    history.replaceState(null, "", path + (qs ? "?" + qs : ""));
  }
  function addSel(key, v) {
    var a = state.filters[key];
    a && a.indexOf(v) < 0 && a.push(v);
  }
  function toggle(key, v) {
    var a = state.filters[key], i = a.indexOf(v);
    i > -1 ? a.splice(i, 1) : a.push(v), state.shown = PER_PAGE, commitOverlay(), [].some.call(els.facets.querySelectorAll("[data-g]"), function(button) {
      return button.getAttribute("data-g") === key && button.getAttribute("data-v") === v ? (button.focus(), true) : false;
    });
  }
  function setFit(v) {
    state.fit = v, state.shown = PER_PAGE, commitAll();
  }
  function applyQ(v) {
    state.q = String(v || "").trim(), state.qTerms = state.q.toLowerCase().split(/\s+/).filter(Boolean);
  }
  function setQ(v) {
    v = String(v || "").trim(), v !== state.q && (applyQ(v), state.shown = PER_PAGE, commitAll());
  }
  function clearAll() {
    state.fit = "Unisex", GROUPS.forEach(function(g) {
      state.filters[g.key] = [];
    }), applyQ(""), [].forEach.call(els.qInputs, function(i) { i.value = ""; }), state.shown = PER_PAGE, commitAll();
  }
  // Winter has a search field and a sort menu in the bar (desktop) and again in the Filters sheet (phones); keep each
  // pair showing the same thing.
  function syncInputs(from) {
    [].forEach.call(from && from.tagName === "SELECT" ? els.sorts : els.qInputs, function(el) {
      el !== from && el.value !== from.value && (el.value = from.value);
    });
  }
  function commitOverlay() {
    state.ready && (renderOverlay(), writeURL());
  }
  function commitAll() {
    state.ready && (renderApplied(), renderFacets(), renderFit(), renderGrid(), writeURL());
  }
  var overlayOpener = null;
  function openOverlay(opener) {
    overlayOpener = opener && opener.focus ? opener : els.openBtn;
    renderApplied(), renderFacets(), els.overlay.classList.add("is-open"), els.overlay.setAttribute("aria-hidden", "false"), document.body.style.overflow = "hidden", els.closeBtn.focus();
  }
  function closeOverlay() {
    els.overlay.classList.remove("is-open"), els.overlay.setAttribute("aria-hidden", "true"), document.body.style.overflow = "", overlayOpener && overlayOpener.focus();
    observeTail();
  }
  function bind() {
    [].forEach.call(els.gswitchTiles, function(box) {
      box.addEventListener("click", function(e) {
        var b = e.target.closest("[data-gswitch]");
        if (!b) return;
        var v = b.getAttribute("data-gswitch");
        // Tapping the garment that is already on goes back to every design (the phone boxes have no "Any").
        state.filters.garment = v && pickedGarment() !== v ? [v] : [], state.shown = PER_PAGE, commitAll(), gtCount("switch");
        var again = box.querySelector('[data-gswitch="' + v.replace(/"/g, '\\"') + '"]');
        again && again.focus();
      });
    });
    if (els.fitBtns = root.querySelectorAll("[data-fit-val]"), [].forEach.call(els.fitBtns, function(b) {
      b.addEventListener("click", function() {
        setFit(b.getAttribute("data-fit-val"));
      });
    }), els.openBtn && els.openBtn.addEventListener("click", function() { gtCount("filters"), openOverlay(); }), els.allBtn && els.allBtn.addEventListener("click", function() { gtCount("filters"), openOverlay(els.allBtn); }), els.closeBtn && els.closeBtn.addEventListener("click", closeOverlay), els.scrim && els.scrim.addEventListener("click", closeOverlay), els.viewBtn && els.viewBtn.addEventListener("click", closeOverlay), [].forEach.call(els.sorts, function(sel) {
      sel.addEventListener("change", function() {
        state.sort = sel.value, state.shown = PER_PAGE, syncInputs(sel), commitAll(), gtCount("sort");
      });
    }), els.qInputs.length) {
      var qTimer = null;
      [].forEach.call(els.qInputs, function(input) {
        input.addEventListener("input", function() {
          syncInputs(input), clearTimeout(qTimer), qTimer = setTimeout(function() {
            setQ(input.value), input.value.trim() && gtCount("search");
          }, 150);
        });
      });
    }
    if (els.searchBtn) {
      // Desktop Winter bar: search is an icon that opens a field ("Search these items", not the header's site search).
      var setOpen = function(open) {
        els.searchWrap.classList.toggle("is-open", open), els.searchBtn.setAttribute("aria-expanded", open ? "true" : "false");
        open && els.searchWrap.querySelector("[data-q]").focus();
      };
      els.searchBtn.addEventListener("click", function() { setOpen(!els.searchWrap.classList.contains("is-open")); });
      els.searchClear && els.searchClear.addEventListener("click", function() {
        [].forEach.call(els.qInputs, function(i) { i.value = ""; }), setQ(""), setOpen(false), els.searchBtn.focus();
      });
      els.searchWrap.addEventListener("keydown", function(e) { e.key === "Escape" && (setOpen(false), els.searchBtn.focus()); });
      document.addEventListener("click", function(e) { els.searchWrap.contains(e.target) || els.searchWrap.classList.contains("is-open") && setOpen(false); });
    }
    els.grid.addEventListener("click", function(e) {
      var c = e.target.closest && e.target.closest(".lig-card");
      c && (gtCount("card"), c.hasAttribute("data-gt-extra") && gtCount("extra"));
    });
    els.more.addEventListener("click", function() {
      appendNext(true);
    }), els.facets.addEventListener("click", function(e) {
      var k = e.target.closest("[data-fit-tile]");
      if (k) {
        state.fit = state.fit === "Kids" ? "Unisex" : "Kids", state.shown = PER_PAGE, commitAll();
        var back = els.facets.querySelector("[data-fit-tile]");
        back && back.focus();
        return;
      }
      var b = e.target.closest("[data-g]");
      b && toggle(b.getAttribute("data-g"), b.getAttribute("data-v"));
    }), els.applied.addEventListener("click", function(e) {
      if (e.target.closest("[data-clear]")) {
        clearAll();
        return;
      }
      var b = e.target.closest("[data-g]");
      b && toggle(b.getAttribute("data-g"), b.getAttribute("data-v"));
    });
    var footClear = root.querySelector(".lig-ov__clear");
    footClear && footClear.addEventListener("click", clearAll), document.addEventListener("keydown", function(e) {
      if (els.overlay.classList.contains("is-open") && (e.key === "Escape" && closeOverlay(), e.key === "Tab")) {
        var buttons = els.overlay.querySelectorAll("button:not([disabled]), a[href], input, select"), first = buttons[0], last = buttons[buttons.length - 1];
        e.shiftKey && document.activeElement === first ? (e.preventDefault(), last.focus()) : !e.shiftKey && document.activeElement === last && (e.preventDefault(), first.focus());
      }
    });
  }
  function renderRecent() {
    var wrap = root.querySelector("[data-rv]"), grid = root.querySelector("[data-rv-grid]");
    if (!wrap || !grid || !state.all.length)
      return;
    var ids = [];
    try {
      ids = JSON.parse(localStorage.getItem("viewedProducts") || "[]") || [];
    } catch (e) {
      return;
    }
    if (!ids.length)
      return;
    ids = ids.slice(0, 4).map(String);
    var byId = {};
    state.all.forEach(function(p) {
      byId[String(p.id)] = p;
    });
    function show(okIds) {
      var cards = [], seen = /* @__PURE__ */ Object.create(null);
      okIds.forEach(function(id) {
        var p = byId[id];
        p && !seen[familyKey(p)] && (seen[familyKey(p)] = true, cards.push(p));
      }), cards.length && (grid.innerHTML = cards.map(function(p, i) {
        return card(p, i + 8);
      }).join(""), wrap.hidden = false);
    }
    var u = new URL("/search/suggest.json", location.origin);
    u.searchParams.set("q", ids.map(function(id) {
      return "id:" + id;
    }).join(" OR ")), u.searchParams.set("resources[type]", "product"), u.searchParams.set("resources[limit]", "4"), fetch(u.toString(), { headers: { Accept: "application/json" } }).then(function(r) {
      return r.json();
    }).then(function(d) {
      var prods = d && d.resources && d.resources.results && d.resources.results.products || [], ok = [];
      prods.forEach(function(rp) {
        if (!isHidden(rp)) {
          var id = String(rp.id);
          byId[id] && ok.push(id);
        }
      }), show(ids.filter(function(id) {
        return ok.indexOf(id) > -1;
      }));
    }).catch(function() {
      show(ids);
    });
  }
  function groupByKey(k) {
    for (var i = 0; i < GROUPS.length; i++)
      if (GROUPS[i].key === k)
        return GROUPS[i];
    return null;
  }
  function handleize(s) {
    return String(s).toLowerCase().replace(/['’]/g, "").replace(/&amp;/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function decodeEnt(s) {
    return String(s).replace(/&amp;/g, "&").replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function(c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function att(s) {
    return esc(String(s)).replace(/"/g, "&quot;");
  }
  function uniq(a) {
    var s = {}, o = [];
    return a.forEach(function(x) {
      x && !s[x] && (s[x] = 1, o.push(x));
    }), o;
  }
  function pushUniq(a, x) {
    x && a.indexOf(x) < 0 && a.push(x);
  }
  function cacheEls() {
    // The Winter heading (above this root) carries arm A's switch under the title; the bar carries the 1180 px+ copy.
    var scope = WINTER ? document : root;
    els.gswitches = scope.querySelectorAll("[data-garment-switch]"), els.gswitchTiles = scope.querySelectorAll("[data-gswitch-tiles]"), els.gswitchHint = scope.querySelector("[data-gswitch-hint]");
    els.grid = root.querySelector("[data-grid]"), els.more = root.querySelector("[data-more]"), els.count = root.querySelector("[data-count]"), els.sorts = root.querySelectorAll("[data-sort]"), els.openBtn = root.querySelector("[data-open-filters]"), els.closeBtn = root.querySelector("[data-close-filters]"), els.overlay = root.querySelector("[data-overlay]"), els.scrim = root.querySelector("[data-ov-scrim]"), els.facets = root.querySelector("[data-facets]"), els.applied = root.querySelector("[data-applied]"), els.viewBtn = root.querySelector("[data-view-btn]"), els.view = root.querySelector("[data-view]"), els.fcount = root.querySelector("[data-filter-count]"), els.qInputs = root.querySelectorAll("[data-q]");
    els.allBtn = root.querySelector("[data-all-products]"), els.allLabel = root.querySelector("[data-all-label]") || els.allBtn;
    els.searchWrap = root.querySelector("[data-search]"), els.searchBtn = els.searchWrap && els.searchWrap.querySelector("[data-search-toggle]"), els.searchLabel = root.querySelector("[data-search-label]") || {}, els.searchClear = root.querySelector("[data-search-clear]");
  }
  function skeleton() {
    var block = '<section class="ligf-block"><div class="ligf-skel__t"></div><div class="ligf-skel__row"><i></i><i></i><i></i><i></i></div></section>';
    return '<div class="ligf-skel" aria-label="Loading filters">' + block + block + block + "</div>";
  }
  function boot() {
    cacheEls(), setupPaging(), loadTiles(), bind(), readURL(), state.q && [].forEach.call(els.qInputs, function(i) { i.value = state.q; }), [].forEach.call(els.sorts, function(s) { s.value = state.sort; }), renderFit(), els.facets && (els.facets.innerHTML = skeleton()), load().then(function() {
      state.ready = true;
      var fits = uniq(state.all.map(function(p) {
        return p.fit;
      }));
      fits.length === 1 && !contextParams.has("fit") && !location.pathname.match(/\/(kids|womens)(?:$|\+)/) && (state.fit = fits[0]), renderApplied(), renderFacets(), renderFit(), renderGrid(), root.classList.remove("lig-shuffling"), root.classList.add("is-ready"), renderRecent();
      // Count this visit in its arm (site counter, once per visit; carts and checkouts later in the visit follow it,
      // and the cart carries the arm so orders can be told apart). Our own visits land in the internal bucket.
      try { GT_COUNTED && window.LIGSiteSignals && window.LIGSiteSignals.enroll && window.LIGSiteSignals.enroll("gt", GT_ARM); } catch (e) { /* never break the grid */ }
    }).catch(function(err) {
      root.classList.remove("lig-shuffling");
      els.facets && (els.facets.innerHTML = '<p class="ligf-empty">Filters couldn\u2019t load \u2014 pull to refresh and try again.</p>'), window.console && console.error("[lig-shop] feed load failed; server grid kept", err);
    });
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot();
})();
